import React from "react";
import Box from "@mui/material/Box";

export default function ImageBlock({ src, alt = "", sx = {} }) {
  return (
    <Box
      sx={{
        width: "100%",
        borderRadius: "30px",
        overflow: "hidden",
        position: "relative",
        boxSizing: "border-box",
        bgcolor: "#ddd",
        height: { xs: 220, sm: 320, md: "591.461px" },
        display: "block",
        ...sx,
      }}
    >
      <Box
        component="img"
        src={src}
        alt={alt}
        sx={{
          width: "100%",
          height: "100%",
          display: "block",
          objectFit: "cover",   
        }}
      />
    </Box>
  );
}
